<!--
 * @FileDescription: 审批-发送流程弹窗组件
 * @Author: qiaofeng
 * @Date: 2021-07-15
 * @LastEditors: qiaofeng
 * @LastEditTime: 2021-07-15
 -->
<template>
	<el-dialog title="发起流程" v-loading="loading" :visible.sync="dialogFormVisible" width="75%" append-to-body>
    <el-form ref="ruleForm" :model="workflow" :rules="rules" label-width="auto">
      <el-row :gutter="10">
        <el-col :span="20" :offset="2">
          <el-form-item label="标题:" prop="name"><el-input v-model="workflow.name" autocomplete="off"></el-input></el-form-item>
        </el-col>
        <el-col :span="12" :offset="2">
          <el-form-item label="业务流程:" prop="deployId">
            <el-select v-model="workflow.deployId" placeholder="请选择业务流程">
              <el-option v-for="item in deployList" :key="item.id" :label="item.definitionName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="priorityId" label-width="0">
            <el-select v-model="workflow.priorityId" placeholder="请选择紧急程度">
              <el-option v-for="item in priorityList" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="20" :offset="2">
          <el-form-item label="关联项目:"><el-input v-model="workflow.projectName" autocomplete="off" disabled></el-input></el-form-item>
        </el-col>
        <el-col :span="20" :offset="2">
          <el-form-item label="消息说明:">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入消息说明" v-model="workflow.remark"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 审批信息列表  -->
    <el-tabs v-model="activeTabsName" class="send-workflow-tabs">
      <el-tab-pane label="审批信息" name="approveTab">
        <el-table ref="approve" :data="approveList" border>
          <el-table-column label="序号" prop="sequenceCode"></el-table-column>
          <el-table-column label="节点名称" prop="name"></el-table-column>
          <el-table-column label="下一步骤" prop="nextStep"></el-table-column>
          <el-table-column label="默认审批人员" prop="defaultAuditor"></el-table-column>
          <el-table-column label="指定审批人员" prop="assignedApprover"></el-table-column>
          <el-table-column label="自由选人" prop="selectPersonFreely"></el-table-column>
          <el-table-column label="说明" prop="remark"></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
		<template slot="footer">
			<el-button type="primary" @click="submitForm('ruleForm')" icon="el-icon-s-promotion" :disabled="sendBtnDisabled">发送</el-button>
			<el-button @click="cancel" icon="el-icon-close">取 消</el-button>
		</template>
	</el-dialog>
</template>

<script>
import WorkflowApi from '@/api/workflow/workflowApi.js';
import WorkflowDeployApi from '@/api/workflow/wfs/deployApi.js';
import DictionaryApi from '@/api/setting/dictionaryApi.js';

export default {
	name: 'send-workflow',
	props: {
		//是否保存再发送
		save:{
			type:Boolean,
			default:false
		}
	},
	data() {
		return {
			sendBtnDisabled: false,
			loading: false,
			dialogFormVisible: false,
			activeTabsName: 'approveTab',
			priorityList: [], // 紧急程度下拉数据
			deployList: [], // 业务流程下拉数据
			approveList: [], //审批信息
			workflow: {}, // 流程对象
			entity:{}, // 主表数据
			rules: {
				name: [{ required: true, message: '请输入流程标题' }],
				deployId: [{ required: true, message: '请选择业务流程' }],
				priorityId: [{ required: true, message: '请选择紧急程度' }]
			},
			callback: null
		};
	},
	created() {},
	methods: {
		/**
		 * @description 获取紧急程度数据
		 */
		getPriorityList() {
			//level  取出枚举数据后  默认值设为第一个
			DictionaryApi.getByDictKey('WorkflowLevel').then(res => {
				if (res != null && res.code == '00000') {
					this.priorityList = res.rows;
					if (this.priorityList != null && this.priorityList.length > 0) {
						this.workflow.priorityId = this.priorityList[0].id;
					}
				}
			});
		},

		/**
		 * @description 获取业务流程数据
		 */
		getDeployList(permissionCode) {
			// workflowSelection 调接口后去数组的第一个元素进行赋值
			WorkflowDeployApi.getDeployList(permissionCode).then(res => {
				if (res != null && res.code == '00000') {
					this.deployList = res.rows;
					if (this.deployList != null && this.deployList.length > 0) {
						this.workflow.deployId = this.deployList[0].id;
						this.getApproveList(this.workflow.deployId);
					}
				}
			});
		},

		/**
		 * @description 获取审批信息数据
		 */
		getApproveList(deployId) {
			//获取审批信息数据
			WorkflowDeployApi.getDeployData(deployId).then(res => {
				if (res != null && res.code == '00000') {
					this.approveList = res.rows;
					this.approveList.map(obj => {
						obj.nextStep = obj.outflows.map(flow => flow.sequenceCode).join();
						obj.defaultAuditor = obj.approvers.map(approver => approver.label).join();
						return obj;
					});
				} else {
					this.$message.warning('无法获取审批信息');
					return;
				}
			});
		},

		/**
		 * @description 打开流程发送弹框
		 * @param {Object} params 流程参数{
		 * name: 流程标题(不为空)
		 * baseUrl: 业务数据url,(不为空)
		 * permissionCode: 资源编码,(不为空)
		 * commitWorkflow: 是否发起流程,(不为空)
		 * auditPageUrl: 详情页面地址,(不为空)
		 * entityCode: 实体code(不为空)
		 * entityId: 实体id(不为空)
		 * projectId: 项目id
		 * projectName: 项目名称
		 * }
		 * @param {Object} entity 主表数据
		 * @param {Function} callback 回调函数
		 */
		openWorkflowDialog(params, entity, callback) {
			if (params == null) {
				this.$message.error('无法获取流程参数!');
				return;
			}
			if (!this.save && (this.$utils.isEmpty(params.entityId) || this.$utils.isEmpty(params.entityCode))) {
				this.$message.error('无法关联业务数据!');
				return;
			}
			if (!this.save && this.$utils.isEmpty(params.permissionCode)) {
				this.$message.error('请确定流程授权编码!');
				return;
			}

			// 流程对象
			if(this.save){
				this.entity = entity
				this.callback = callback;
			}else{
				this.callback = entity;
			}
			this.workflow = this.defaultWorkflow();

			// 1.校验权限
			// 2.校验业务数据

			// 标题
			let title = params.title;
			if (title == null) {
				title = params.entityCode;
			}
			this.workflow.name = title;
			this.workflow.remark = (title ? title:'') + ',请批准。';

			this.workflow.baseUrl = params.baseUrl;
			this.workflow.permissionCode = params.permissionCode;
			this.workflow.auditPageUrl = params.auditPageUrl;
			this.workflow.objectCode = params.entityCode;
			this.workflow.objectId = params.entityId;
			this.workflow.projectId = params.projectId;
			this.workflow.projectName = params.projectName;

			// 获取紧急程度
			this.getPriorityList();
			// 获取业务流程
			this.getDeployList(this.workflow.permissionCode);

			// 弹框显示
			this.dialogFormVisible = true;
		},

		/**
		 * @description 校验业务数据
		 * @param {String} baseUrl 业务baseUrl
		 * @param {String} entityId 业务id
		 */
		isEnableWorkflow(baseUrl, entityId) {},

		/**
		 * @description 流程发送
		 */
		async submitForm(formName) {
			try {
				const valid = await this.$refs[formName].validate();
				let res;
				if (valid) {
					this.loading = true;
					this.sendBtnDisabled = true;
					this.workflow.wfdActivities = this.approveList;
					if (this.save) {
						res = await WorkflowApi.saveAndSend(this.workflow.baseUrl, this.entity, this.workflow, { loading: this.loading });
					} else {
						res = await WorkflowApi.send(this.workflow.baseUrl, this.workflow.objectId, this.workflow, { loading: this.loading });
					}

					if (res?.code == '00000') {
						this.$message.success('流程发送成功!');
						typeof this.callback === 'function' && this.callback(res);
						this.cancel();
					}
				}
			} catch (error) {}

			this.loading = false;
		},

		/**
		 * @description 取消发送
		 */
		cancel() {
			this.sendBtnDisabled = false;
			this.dialogFormVisible = false;
			this.workflow = this.defaultWorkflow();
		},

		defaultWorkflow() {
			return {
				name: null, //标题
				deployId: null, //选中流程id
				priorityId: null, //紧急程度
				commitWorkflow: false,
				remark: null, //消息说明

				objectId: null, //发起流程实体id
				objectCode: null, //发起流程实体code
				auditPageUrl: null, //审批页面url
				baseUrl: null,
				permissionCode: null, // 资源码
				projectId: null, //项目id
				projectName: null, // 项目名称
				wfdActivities: [] //审批信息数据
			};
		}
	}
};
</script>

<style lang="less" scoped>
& /deep/ .send-workflow-tabs {
	.el-table {
		margin-top: 0 !important;
		height: 300px;
	}
}

:deep(.el-table) {
  .el-table__cell {
    padding: 6px 0 !important;
  }
}
</style>
